export const serviceProviders = {
  // NOTE: MLS Broker partnerships in development - Enable via Admin Dashboard when ready
  // Controlled by platform_settings.mls_features_enabled flag
  mlsBrokers: [
    // Partnerships to be added once contracts are signed
    // Use /app/BROKER_PARTNERSHIP_OUTREACH.md to initiate discussions
  ],

  // Home Warranties (Closing Essential - $50-100/policy)
  homeWarranties: [
    {
      name: "Liberty Home Guard",
      description: "Top-rated in Texas with customizable plans ($500-800/year). Comprehensive coverage for appliances, systems, and more. Serves all DFW.",
      website: "https://libertyhomeguard.com/affiliates",
      referralNotes: "Highest commissions ($100/policy). Dedicated realtor program with co-marketing.",
      referralBonus: "$100 per policy",
      highlights: ["Top TX ratings", "$500-800/year", "Customizable plans", "Fast claims"],
      featured: true,
      urgencyCTA: "Protect Your Sale & Get Quote →"
    },
    {
      name: "Choice Home Warranty",
      description: "$45-60/month plans with fast claims processing. DFW-focused representatives available.",
      website: "https://choicehomewarranty.com/affiliate",
      referralNotes: "Up to $150/lead via CJ Affiliate. Weekly payouts, easy for FSBO sites.",
      referralBonus: "Up to $150/lead",
      highlights: ["$45-60/month", "Fast claims", "DFW reps", "Weekly payouts"],
      urgencyCTA: "Get Coverage →"
    },
    {
      name: "American Home Shield (AHS)",
      description: "Comprehensive coverage with local DFW representatives for quick service. Bundles with title/escrow partners.",
      website: "https://ahs.com/real-estate-pros",
      referralNotes: "$50-75/referral. Bundles with title/escrow partners.",
      referralBonus: "$50-75 per referral",
      highlights: ["Comprehensive coverage", "Local DFW reps", "Quick service", "Escrow bundles"],
      urgencyCTA: "Bundle & Save →"
    },
    {
      name: "Cinch Home Services",
      description: "Appliance/system focus with 180-day workmanship guarantee. Real estate-specific portal for tracking.",
      website: "https://cinchhomeservices.com/partners",
      referralNotes: "20% commission. Real estate-specific portal for tracking.",
      referralBonus: "20% Commission",
      highlights: ["180-day guarantee", "Appliance focus", "RE tracking portal", "System coverage"],
      urgencyCTA: "Get Quote →"
    }
  ],

  // Moving Companies (Post-Sale - $100-300/referral)
  movers: [
    {
      name: "Wildcat Movers",
      description: "Local DFW experts with full-service packing and storage. Covers Plano to Fort Worth. Real estate partner program.",
      website: "https://wildcatmovers.com",
      referralNotes: "$100-200/referral. Real estate partner program with volume discounts.",
      referralBonus: "$100-200 per referral",
      highlights: ["Full DFW coverage", "Packing & storage", "Volume discounts", "Local experts"],
      featured: true,
      urgencyCTA: "Get Free Quote & Save 10% →"
    },
    {
      name: "Einstein Moving Co.",
      description: "High-end moves with 96% referral rate. Handles McKinney, Highland Park, and luxury relocations.",
      website: "https://einsteinmoving.com/dallas",
      referralNotes: "15% commission. Co-brands with FSBO sites for exclusive quotes.",
      referralBonus: "15% Commission",
      highlights: ["96% referral rate", "Luxury focus", "Highland Park", "Co-branding available"],
      urgencyCTA: "Get Exclusive Quote →"
    },
    {
      name: "Evolution Moving",
      description: "Affordable local/long-distance with 4.9/5 stars. DFW metro focus. Affiliate-friendly for real estate leads.",
      website: "https://evolutionmoving.com",
      referralNotes: "$150/job. Affiliate-friendly for real estate leads.",
      referralBonus: "$150 per job",
      highlights: ["4.9/5 stars", "Affordable rates", "Local & long-distance", "DFW metro"],
      urgencyCTA: "Book Now & Save →"
    },
    {
      name: "Firehouse Movers",
      description: "20+ years, firefighter-owned. Quick Dallas-Fort Worth relocations with trusted service.",
      website: "https://firehousemovers.com",
      referralNotes: "Referral bonuses ($50-100). Partners with agents for bundled services.",
      referralBonus: "$50-100 per referral",
      highlights: ["Firefighter-owned", "20+ years", "Quick relos", "Bundled services"],
      urgencyCTA: "Get Quote →"
    },
    {
      name: "United Van Lines (Berger)",
      description: "National with DFW hub. Storage included with free quotes. Real estate affiliate network for high-volume.",
      website: "https://bergerallied.com/dallas-movers",
      referralNotes: "$200+/move. Real estate affiliate network for high-volume.",
      referralBonus: "$200+ per move",
      highlights: ["National network", "DFW hub", "Storage included", "High-volume rates"],
      urgencyCTA: "Get Free Quote →"
    }
  ],

  staging: [
    {
      name: "DFW Staging",
      description: "Full-service staging for homes across Dallas, Fort Worth, and suburbs like Plano and Frisco. Specializes in customized plans to highlight home features.",
      website: "https://dfw-staging.com",
      referralNotes: "Works closely with realtors; open to referral partnerships for FSBO sellers. Inquire about commission structures.",
      referralBonus: "10-20% Commission",
      highlights: ["Custom staging plans", "Covers all DFW metro", "Realtor partnerships"]
    },
    {
      name: "Charter Furniture Solutions",
      description: "High-style vacant and occupied staging with 40+ years in DFW. Offers free consultations and trends-aligned designs.",
      website: "https://charterfurnituresolutions.com",
      referralNotes: "Targets real estate pros; potential for affiliate-style referrals via their agent network.",
      highlights: ["40+ years experience", "Free consultations", "Vacant & occupied staging"]
    },
    {
      name: "Atmospheric Home Staging",
      description: "Large inventory for realtors, builders, and investors in Dallas/Fort Worth. Claims staged homes sell 88% faster.",
      website: "https://atmospherichome.com",
      referralNotes: "Referral-friendly for real estate sites; contact for monetization options.",
      highlights: ["88% faster sales", "Large inventory", "Builder & investor focused"]
    },
    {
      name: "Prime Home Staging Dallas",
      description: "Luxury staging in Dallas, Fort Worth, Plano, and Frisco. Focuses on faster sales (79% quicker per NAR stats).",
      website: "https://primehomestagingdallas.com",
      referralNotes: "Partners with agents; suitable for FSBO referral commissions.",
      highlights: ["Luxury focus", "79% faster sales", "DFW coverage"]
    },
    {
      name: "Stage Right Texas",
      description: "Flat-rate vacant staging starting at $2,495 (no rentals). Serves Dallas area.",
      website: "https://houzz.com",
      referralNotes: "Affordable for FSBO; open to agent referral programs.",
      referralBonus: "Flat $2,495",
      highlights: ["Flat-rate pricing", "No rental fees", "Vacant staging specialist"]
    },
    {
      name: "Texas Best Stagers",
      description: "Customized staging for homeowners and realtors in DFW. Emphasizes 'model home' appeal.",
      website: "https://texasbeststagers.com",
      referralNotes: "Strong realtor partnerships; inquire about affiliate referrals.",
      highlights: ["Model home appeal", "Custom designs", "Homeowner & realtor focused"]
    },
    {
      name: "Casa Bella Staging + Design",
      description: "Elevated concepts for Dallas-Fort Worth properties. Helped secure offers in 48 hours.",
      website: "https://casabelladallas.com",
      referralNotes: "Works with investors/realtors; potential for referral fees.",
      highlights: ["48-hour offer track record", "Elevated design", "Investor partnerships"]
    },
    {
      name: "George Bass Stage & Design",
      description: "Luxury staging for agents, builders, and investors in DFW. Custom furniture/art.",
      website: "https://georgebassdesign.com",
      referralNotes: "Premier for high-end FSBO; referral opportunities via testimonials.",
      highlights: ["Luxury market", "Custom furniture & art", "High-end focus"]
    }
  ],

  cleaning: [
    {
      name: "The Mop & Broom",
      description: "Real estate-specific move-out and prep cleaning for agents in Fort Worth and DFW.",
      website: "https://themopandbroom.com",
      referralNotes: "Tailored for realtors; referral program via agent partnerships (commissions on bookings).",
      highlights: ["Real estate specialized", "Move-out cleaning", "Agent focused"]
    },
    {
      name: "Zerorez",
      description: "Carpet, air duct, and deep cleaning with eco-friendly tech. Serves DFW metro.",
      website: "https://zerorez.com/affiliates",
      referralNotes: "$40 commission per new customer job, $30 for repeats. Ideal for FSBO site affiliates in cleaning/home niches.",
      referralBonus: "$40/job",
      highlights: ["Eco-friendly", "Carpet & air ducts", "Structured affiliate program"]
    },
    {
      name: "Clean Affinity",
      description: "Recurring, one-time, and move-in/out cleans in Dallas-Fort Worth.",
      website: "https://cleanaffinity.com",
      referralNotes: "Agent-focused; inquire for referral discounts/commissions.",
      highlights: ["Flexible scheduling", "Move-in/out specialist", "Recurring services"]
    },
    {
      name: "Dalworth Rug Cleaning",
      description: "Part of Dalworth Companies; full cleaning/restoration in DFW/North Texas since 1976. Uses Referral Central.",
      website: "https://referral-central.com",
      referralNotes: "Structured referral program for partners; commissions on referred services.",
      highlights: ["Since 1976", "Full restoration", "Referral Central platform"]
    },
    {
      name: "Dallas Janitorial Services",
      description: "Tailored real estate cleans (curb appeal, interiors) with 2025 pricing updates.",
      website: "https://dallasjanitorialservices.com",
      referralNotes: "Repeat business via referrals; potential affiliate ties for agents.",
      highlights: ["Real estate tailored", "Curb appeal focus", "Updated pricing"]
    },
    {
      name: "Kleen-It Maids",
      description: "Residential/commercial cleans including move-out in DFW (Dallas, Fort Worth, Arlington).",
      website: "https://angi.com",
      referralNotes: "Referred by agents/property managers; commission opportunities.",
      highlights: ["Move-out specialist", "DFW coverage", "Residential & commercial"]
    },
    {
      name: "Office Pride of Dallas-Fort Worth",
      description: "Commercial/residential cleaning with local focus.",
      website: "https://officepride.com/dallas-fort-worth",
      referralNotes: "Referral program for real estate pros; earn on bookings.",
      highlights: ["Local focus", "Commercial & residential", "Booking commissions"]
    }
  ],

  photography: [
    {
      name: "DallasPro",
      description: "DFW photography, videography, Matterport 3D tours, and virtual staging.",
      website: "https://dallaspro.com",
      referralNotes: "Agent partnerships; referral commissions on shoots (contact for details).",
      highlights: ["3D tours", "Virtual staging", "Full media package"]
    },
    {
      name: "DFW 360 Media",
      description: "Photos, videos, 3D tours, floor plans, and reels for Dallas-Fort Worth listings.",
      website: "https://dfw360media.com",
      referralNotes: "High engagement focus; affiliate potential via realtor network.",
      highlights: ["360° tours", "Floor plans", "Social media reels"]
    },
    {
      name: "Hometrack Real Estate Marketing",
      description: "Unlimited HDR photos, drone, and twilight shots in DFW. 20% off first session.",
      website: "https://hometrack.net/dallas",
      referralNotes: "Targets top agents; referral discounts/commissions available.",
      referralBonus: "20% off 1st session",
      highlights: ["Unlimited HDR", "Drone shots", "Twilight photography"]
    },
    {
      name: "Texas Takes Real Estate Photography",
      description: "Residential/commercial photos, video, drone, and 3D tours in DFW/North Texas.",
      website: "https://texastakesrephoto.com",
      referralNotes: "Local focus; open to FSBO site referrals.",
      highlights: ["Commercial photos", "Drone video", "North Texas coverage"]
    },
    {
      name: "Full Package Media",
      description: "Top-rated DFW photography/videography with 3D tours and drone.",
      website: "https://fullpackagemedia.com",
      referralNotes: "Reviewed #1; agent referral program with commissions.",
      rating: "5.0",
      highlights: ["#1 rated", "Complete packages", "Drone included"]
    },
    {
      name: "Real Estate Bees (Platform)",
      description: "Connects to DFW photographers/videographers; lifetime recurring commissions.",
      website: "https://realestatebees.com/partners/affiliates",
      referralNotes: "Up to 50% commissions on referrals; perfect for your site to monetize media leads.",
      referralBonus: "Up to 50% recurring",
      highlights: ["Platform marketplace", "Lifetime commissions", "Multiple providers"]
    }
  ],

  attorneys: [
    {
      name: "Jones, Allen & Fuquay, L.L.P.",
      description: "Commercial/residential real estate transactions, compliance in Dallas area.",
      website: "https://jonesallen.com",
      referralNotes: "Realtor partnerships; referral fees for FSBO leads.",
      highlights: ["Commercial & residential", "Compliance specialist", "Dallas focus"]
    },
    {
      name: "The Farah Law Firm",
      description: "Residential real estate docs, contracts, disputes in Mansfield/DFW.",
      website: "https://farahlegal.com",
      referralNotes: "Handles non-traditional sales; open to affiliate referrals.",
      highlights: ["Contract specialist", "Dispute resolution", "Mansfield/DFW"]
    },
    {
      name: "The Cramer Law Group",
      description: "Transactions, litigation for residential/commercial in Dallas. Free consults.",
      website: "https://mrctexlaw.com",
      referralNotes: "Agent-focused; commission on referred closings.",
      highlights: ["Free consultations", "Litigation support", "Commercial expertise"]
    },
    {
      name: "The Lonergan Law Firm",
      description: "Title closings, contracts, heirship issues in Dallas.",
      website: "https://yelp.com",
      referralNotes: "Strong reviews; referral program via real estate pros.",
      highlights: ["Title closings", "Heirship issues", "Contract review"]
    },
    {
      name: "Cox Law Firm",
      description: "Residential/commercial in Fort Worth; development/sales.",
      website: "https://edcoxlaw.com",
      referralNotes: "Local expertise; inquire for FSBO referral partnerships.",
      highlights: ["Fort Worth focus", "Development", "Commercial sales"]
    },
    {
      name: "Richard Weaver & Associates",
      description: "Short sales, foreclosures, debt relief in Fort Worth/Dallas.",
      website: "https://expertise.com",
      referralNotes: "30+ years; referral network for agents.",
      highlights: ["30+ years experience", "Short sale specialist", "Debt relief"]
    }
  ],

  titleCompanies: [
    {
      name: "Allegiance Title",
      description: "Full-service closings, title insurance in DFW. Tools for agents.",
      website: "https://allegiancetitle.com",
      referralNotes: "Agent referral program; commissions on transactions.",
      referralBonus: "25-40% of premiums",
      highlights: ["Agent tools", "Full-service", "DFW coverage"]
    },
    {
      name: "Republic Title of Texas",
      description: "Title transfers, protection since 1991 in DFW.",
      website: "https://republictitle.com",
      referralNotes: "Partners with realtors; referral fees for closings.",
      highlights: ["Since 1991", "Title protection", "Transfer specialist"]
    },
    {
      name: "Independence Title",
      description: "Residential/commercial escrow in DFW (13+ years).",
      website: "https://independencetitle.com",
      referralNotes: "Expert agent guidance; structured referral commissions.",
      highlights: ["13+ years", "Escrow services", "Agent guidance"]
    },
    {
      name: "Lawyers Title",
      description: "Title insurance, escrow, 1031 exchanges in Dallas-Fort Worth.",
      website: "https://dfw.ltic.com",
      referralNotes: "Realtor-focused; affiliate-style referrals.",
      highlights: ["1031 exchanges", "Escrow", "Realtor focused"]
    },
    {
      name: "Alamo Title",
      description: "Best-in-class services statewide, DFW offices.",
      website: "https://dfw.alamotitle.com",
      referralNotes: "Referral partnerships for smooth closings.",
      highlights: ["Statewide", "Multiple DFW offices", "Best-in-class"]
    },
    {
      name: "Sendera Title",
      description: "Family-owned with 11 DFW offices; attorney-led.",
      website: "https://senderatitle.com",
      referralNotes: "Commissions for agent referrals; quick transactions.",
      highlights: ["11 DFW offices", "Attorney-led", "Family-owned"]
    },
    {
      name: "Chicago Title DFW",
      description: "Residential title/escrow, construction disbursing.",
      website: "https://dallas.ctic.com",
      referralNotes: "Strong agent network; referral program available.",
      highlights: ["Construction disbursing", "National brand", "Agent network"]
    },
    {
      name: "Texas Premier Title",
      description: "Title deeds, transfers across DFW.",
      website: "https://txprem.com",
      referralNotes: "App-based tools; referral commissions for FSBO.",
      highlights: ["App-based", "Deed specialist", "DFW coverage"]
    }
  ],

  homeInspectors: [
    {
      name: "TexInspec",
      description: "Residential/commercial inspections with 200% guarantee in DFW (100+ communities).",
      website: "https://texinspec.com",
      referralNotes: "Top-rated; referral program for agents (discounts/commissions).",
      referralBonus: "10-20% discount",
      rating: "4.9",
      highlights: ["200% guarantee", "100+ communities", "Top-rated"]
    },
    {
      name: "Green Scene Home Inspections",
      description: "Licensed inspections with video reports in Dallas/Fort Worth.",
      website: "https://greenscenehomeinspections.com",
      referralNotes: "Family-owned; agent partnerships for FSBO referrals.",
      highlights: ["Video reports", "Family-owned", "Licensed"]
    },
    {
      name: "Level Up Home Inspections",
      description: "TREC/InterNACHI certified; thousands of DFW inspections.",
      website: "https://dfwtopinspect.com",
      referralNotes: "Referral-friendly; commissions on bookings.",
      highlights: ["TREC certified", "InterNACHI member", "Thousands completed"]
    },
    {
      name: "The Home Inspectors",
      description: "Competitive pricing with extras in DFW/Austin/Houston.",
      website: "https://thehomeinspectorstx.com",
      referralNotes: "High reviews; agent referral discounts.",
      rating: "4.8",
      highlights: ["Competitive pricing", "Multi-city", "Extras included"]
    },
    {
      name: "HomeTeam of DFW",
      description: "Team-based fast inspections (pest, pool, new construction) in Dallas/Colleyville.",
      website: "https://hometeam.com/dfw",
      referralNotes: "Empowers agents; referral program with perks.",
      referralBonus: "$50-100 per inspection",
      highlights: ["Team-based", "Pest inspections", "Pool inspections"]
    },
    {
      name: "Stonebriar Property Inspections",
      description: "Detailed reports since 2007 in Dallas/Fort Worth.",
      website: "https://stonebriarpropertyinspections.com",
      referralNotes: "Local focus; open to FSBO site affiliates.",
      highlights: ["Since 2007", "Detailed reports", "Local expertise"]
    },
    {
      name: "A-Pro DFW",
      description: "Comprehensive buyer/seller inspections with add-ons like WDI.",
      website: "https://aprodfw.com",
      referralNotes: "30+ years; referral fees for real estate pros.",
      highlights: ["30+ years", "WDI inspections", "Add-on services"]
    },
    {
      name: "InterSpect Home Inspections",
      description: "Tech-forward residential in DFW Metroplex.",
      website: "https://interspecttx.com",
      referralNotes: "TREC-licensed; agent referral commissions.",
      highlights: ["Tech-forward", "TREC-licensed", "Modern reports"]
    }
  ],

  painting: [
    {
      name: "Southern Painting",
      description: "Interior/exterior house painting across Dallas-Fort Worth, including custom finishes and drywall repairs. Serves suburbs like Plano and Arlington.",
      website: "https://southernpainting.com",
      referralNotes: "Dedicated 'Refer A Friend' program with appreciation rewards (e.g., gift cards or discounts); ideal for FSBO site commissions on seller leads.",
      highlights: ["Custom finishes", "Drywall repairs", "All DFW suburbs"]
    },
    {
      name: "ATD Painting",
      description: "Trusted for real estate prep; full interior/exterior services with detailed estimates. Highly recommended by Dallas realtors for quick turnarounds.",
      website: "https://atdpainting.com",
      referralNotes: "Strong realtor referral network; 15+ years of agent partnerships offering commissions or reciprocal leads for FSBO referrals.",
      highlights: ["Real estate specialist", "Quick turnaround", "15+ years"]
    },
    {
      name: "Landmark Property Services (DFW Paint Pros)",
      description: "Residential/commercial painting and repairs in Fort Worth and DFW. Focuses on quality finishes for pre-sale staging.",
      website: "https://dfw-paintpros.com",
      referralNotes: "Cash referral bonuses: $50 for jobs under $600, $100 for larger projects; contingent on booking—perfect for website monetization.",
      referralBonus: "$50-$100",
      highlights: ["Pre-sale specialist", "Cash bonuses", "Quality finishes"]
    },
    {
      name: "Platinum Painting",
      description: "Luxury repainting for Dallas/Fort Worth homes, specializing in large estates and exteriors. Serves Frisco, Mansfield, and Keller.",
      website: "https://platinumpainting.com",
      referralNotes: "Over 50% of business from referrals; offers agent incentives like discounts or fees for FSBO seller intros.",
      highlights: ["Luxury focus", "Large estates", "50% referral business"]
    },
    {
      name: "WOW 1 DAY PAINTING",
      description: "One-day interior/exterior transformations in Grapevine, Southlake, and Trophy Club. Eco-friendly options for curb appeal boosts.",
      website: "https://wow1day.com/locations/dallas-fort-worth",
      referralNotes: "Referral-friendly with free quotes; partners with real estate pros for commissions on quick pre-listing jobs.",
      highlights: ["One-day service", "Eco-friendly", "Quick turnaround"]
    },
    {
      name: "Gilques Painting DFW",
      description: "Affordable full-house painting with color consultations for Texas weather. Covers Dallas, Fort Worth, and McKinney.",
      website: "https://gilquespaintingdfw.com",
      referralNotes: "Client referral rewards; open to affiliate ties for FSBO sites, emphasizing value-driven partnerships.",
      highlights: ["Affordable", "Color consultation", "Weather-resistant"]
    },
    {
      name: "Spray Tex Painting",
      description: "Family-owned interior/exterior services for whole homes in DFW metro. Quick, clean jobs with warranty follow-ups.",
      website: "https://spraytexpainting.com",
      referralNotes: "Encourages referrals via testimonials; potential for cash incentives—contact for FSBO-specific agreements.",
      highlights: ["Family-owned", "Warranty included", "Quick & clean"]
    },
    {
      name: "Dallas Pro Paint & Drywall",
      description: "Metroplex-wide painting with prep for sales; insured for stress-free service.",
      website: "https://dallaspropaint.com",
      referralNotes: "Accepts real estate referrals; inquire about commission structures for website-driven leads.",
      highlights: ["Insured", "Sale prep", "Metroplex-wide"]
    }
  ],

  handyman: [
    {
      name: "Mr. Handyman of Dallas",
      description: "Full maintenance for homes/businesses: drywall, painting, electrical, and utility-saving upgrades in Dallas metro.",
      website: "https://mrhandyman.com/dallas",
      referralNotes: "Neighborly affiliate network with referral promotions; earn on leads via their pro program for FSBO sites.",
      highlights: ["National brand", "Full maintenance", "Utility upgrades"]
    },
    {
      name: "DTX Handyman Services",
      description: "Veteran/woman-owned: Drywall, assembly, painting, and seasonal prep for real estate investors in Dallas, Plano, Frisco.",
      website: "https://dtxhandymanservices.com",
      referralNotes: "Serves realtors/HOAs; referral discounts/commissions for agent partners—tailored for FSBO exterior fixes.",
      highlights: ["Veteran-owned", "Real estate focused", "HOA services"]
    },
    {
      name: "Kaminskiy Care & Repair",
      description: "Comprehensive repairs (plumbing, electrical, painting) for Dallas homeowners prepping for sale.",
      website: "https://careandrepair.com/tx/dallas-local-handyman",
      referralNotes: "High referral volume; offers bonuses for successful intros, with strong real estate testimonials.",
      referralBonus: "$50-100",
      highlights: ["Comprehensive repairs", "Pre-sale prep", "Plumbing & electrical"]
    },
    {
      name: "Make Ready Residential",
      description: "Make-ready services: Minor repairs, cleanups, and handyman work for DFW sellers/landlords to boost sale speed.",
      website: "https://makereadyresidential.com",
      referralNotes: "Realtor-focused; referral fees for property prep leads—ideal for monetizing FSBO curb appeal packages.",
      highlights: ["Make-ready specialist", "Quick turnaround", "Seller focused"]
    },
    {
      name: "DFW Improved",
      description: "Exterior repairs, painting, and maintenance to enhance curb appeal year-round in Dallas-Fort Worth.",
      website: "https://dfwimproved.com/home-repair",
      referralNotes: "Referral rewards for pros; partners with real estate for commissions on pre-sale fixes.",
      highlights: ["Curb appeal specialist", "Year-round service", "Exterior focus"]
    },
    {
      name: "Handyman Connection (DFW)",
      description: "Exterior upgrades like soffits, fascia, and trim for Dallas curb appeal; quick response for sellers.",
      website: "https://handymanconnection.com/dallas",
      referralNotes: "National referral program with local incentives; earn on jobs from FSBO website traffic.",
      highlights: ["Exterior specialist", "Quick response", "National backing"]
    },
    {
      name: "Pro Referral (Home Depot)",
      description: "Marketplace for handymen in DFW; connects to sellers for repairs via Home Depot leads.",
      website: "https://proreferral.homedepot.com",
      referralNotes: "Cost-free leads for pros; affiliate-style earnings for site referrals to vetted handymen.",
      highlights: ["Home Depot network", "Vetted pros", "Marketplace platform"]
    }
  ],

  landscaping: [
    {
      name: "Green Earth DFW",
      description: "Lawn mowing, landscaping, and WOWscapes (outdoor kitchens) for Dallas-Fort Worth homes pre-sale.",
      website: "https://greenearthdfw.com",
      referralNotes: "Local loyalty programs; open to realtor referrals with discounts/commissions for FSBO yard refresh leads.",
      highlights: ["Outdoor kitchens", "Pre-sale focus", "Loyalty rewards"]
    },
    {
      name: "Southern Botanical",
      description: "Full maintenance, design-build, and irrigation for residential curb appeal in Dallas/Fort Worth.",
      website: "https://southernbotanical.com",
      referralNotes: "30+ years serving real estate; referral partnerships for seasonal enhancements and seller prep.",
      highlights: ["30+ years", "Design-build", "Irrigation systems"]
    },
    {
      name: "Peterson's Landscape",
      description: "Lawn care, hardscaping, and design for Fort Worth properties; 35+ years in commercial/residential.",
      website: "https://petersonslandscape.com",
      referralNotes: "Reputation-driven referrals; incentives for agents introducing FSBO clients for yard makeovers.",
      highlights: ["35+ years", "Hardscaping", "Commercial & residential"]
    },
    {
      name: "U.S. Lawns Fort Worth",
      description: "Commercial/residential mowing and maintenance in Arlington, Irving, and DFW Airport area.",
      website: "https://uslawns.com/locations/tx/ft-worth",
      referralNotes: "Customized plans with referral perks; strong real estate network for curb appeal boosts.",
      highlights: ["Airport area", "Custom plans", "Commercial specialist"]
    },
    {
      name: "Lonestar Landscape",
      description: "Outdoor living installs (patios, fire pits) and yard work for Fort Worth/Dallas budgets $30K+.",
      website: "https://lonestarlandscape.com",
      referralNotes: "Client referral rewards; partners with sellers for value-adding exterior transformations.",
      highlights: ["Outdoor living", "$30K+ projects", "Fire pits & patios"]
    },
    {
      name: "Lawns of Dallas",
      description: "Year-round residential/commercial landscaping with hardscaping for DFW curb appeal.",
      website: "https://lawnsofdallas.com",
      referralNotes: "Expert insights shared with realtors; commission opportunities for FSBO site referrals.",
      highlights: ["Year-round", "Hardscaping", "Expert insights"]
    },
    {
      name: "Blooms Landcare",
      description: "Commercial/residential maintenance (grass, gardens) in Dallas/Fort Worth; year-round plans.",
      website: "https://bloomslandcare.com",
      referralNotes: "Referral-friendly with testimonials; discounts for real estate pros on seller yard services.",
      highlights: ["Garden maintenance", "Year-round plans", "Commercial & residential"]
    },
    {
      name: "TS Landscape Services DFW",
      description: "Full-service lawn/landscape for North Texas (Aledo, Mansfield); low-maintenance designs.",
      website: "https://tslandscapeservicesdfw.com",
      referralNotes: "Tailored for homeowners; inquire about affiliate commissions for FSBO plant/trim recommendations.",
      highlights: ["Low-maintenance", "North Texas", "Full-service"]
    },
    {
      name: "Greenview Landscaping",
      description: "Routine yardwork, drainage, and patios for Fort Worth homes/businesses.",
      website: "https://greenviewdfw.com",
      referralNotes: "Professional referrals encouraged; financing for larger jobs suits FSBO monetization.",
      highlights: ["Drainage specialist", "Patio installation", "Financing available"]
    },
    {
      name: "Dallas Curb Appeal",
      description: "Landscape design and installs to enhance home value; priority for past clients.",
      website: "https://dallascurbappeal.com",
      referralNotes: "Generous referral rewards (e.g., credits); email-based for easy FSBO tracking.",
      highlights: ["Value enhancement", "Design & install", "Referral credits"]
    }
  ]
};
